import styled, { css } from 'styled-components';
import { media, DeprecatedGrid as Grid, Button } from '@simplywallst/ui-core';

export const Wrapper = styled('header')`
  ${media.lgUp`
    margin-top: ${({ theme }) => theme.x1spacePx}px;
  `}
`;

export const TextHeader = styled(Grid)`
  > h1 {
    margin-top: ${({ theme }) => theme.x2spacePx}px;
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  }
  margin-top: -${({ theme }) => theme.x2spacePx}px;
  ${media.mdDown`
    margin-top: -${({ theme }) => theme.x1spacePx}px;
  `}
`;

export const Avatar = styled('div')`
  height: ${({ theme }) => theme.x3spacePx}px;
  width: ${({ theme }) => theme.x3spacePx}px;
  border-radius: ${({ theme }) => theme.x3spacePx}px;
  background: ${({ theme }) => theme.color.noir};
  border: 1px solid ${({ theme }) => theme.color.white};
  overflow: hidden;
`;

export const DescriptionWrapper = styled('div')`
  ${({ theme }) => theme.typography.small}
  position: relative;
  background: ${({ theme }) => theme.color.noir};
  border-bottom-left-radius: ${({ theme }) => theme.x1spacePx}px;
  border-bottom-right-radius: ${({ theme }) => theme.x1spacePx}px;
  margin-top: -${({ theme }) => theme.x3spacePx}px;
  padding: ${({ theme }) => `${theme.x3spacePx}px ${theme.x4spacePx}px`};
  ${media.mdDown`
    margin-top: -${({ theme }) => theme.x1spacePx}px;
    padding: ${({ theme }) => theme.x2spacePx}px;
    border-radius: 0;
  `}
`;

const gradientCSS = css`
  &:before {
    ${({ theme }) => css`
      background: linear-gradient(
        180deg,
        ${theme.color.noirRGBA(0)} 0%,
        ${theme.color.noirRGBA(0.6)} 50%,
        ${theme.color.noirRGBA(0.9)} 80%,
        ${theme.color.noirRGBA(1)} 95%,
        ${theme.color.noirRGBA(1)} 100%
      );
    `}
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: ${({ theme }) => theme.x5spacePx}px;
    bottom: 0;
    left: 0;
    pointer-events: none;
  }
`;

const innerHTMLCSS = css`
  /* Server supplied HTML styling */
  li {
    margin-bottom: ${({ theme }) => theme.x2spacePx}px;
    &:last-of-type {
      margin: 0;
    }
  }
  ul {
    padding-left: ${({ theme }) => theme.x2spacePx}px;
    li {
      list-style-type: square;
      &::marker {
        color: ${({ theme }) => theme.color.brand03};
      }
    }
  }
`;

export const ShowMoreButton = styled(Button)`
  opacity: 0.5;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const Content = styled('div')<{ open: boolean }>`
  max-height: ${({ open }) => (open ? 'auto' : '160px')};
  ${media.smDown`
    max-height: ${({ open }) => (open ? 'auto' : '55vh')};
  `}
  overflow-y: hidden;
  position: relative;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  ${media.mdDown`
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  `}
  ${({ open }) => !open && gradientCSS}
  ${innerHTMLCSS}
`;
